// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cardCta":"_2P_0C3","cta":"_2fgjSN","ctaSubtitle":"JtmeEF"};